<template>
  <div class="u-wrap">
    <div class="card">
      <van-cell title="咨询留言" value="" :border="false" />
      <textarea placeholder="请填写详细内容" class="xxnr" v-model="object.zxly" readonly></textarea>
      <div class="time">时间：{{ object.createTime }}</div>
    </div>

    <div  class="card">
      <van-cell title="回复内容" value="" required :border="false" />
      <textarea placeholder="请填写详细内容" class="xxnr" v-model="model.hfnr" ></textarea>
    </div>

    <div class="b-btn">
      <button class="b-button" :disabled="disabled" @click="clickSumbit">提交</button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import qzzxCard from '@/views/common/qzzx-card.vue'
export default {
  components: {
    qzzxCard,
  },
  data() {
    return {
      url: '/zhshj/seekhelp/add',
      object: {},
        model: {
          hfnr: '1111111',
        },
      id: '',
    }
  },
  created() {
    this.model.id = this.$route.query.id
    this.getData()
  },
  mounted() {},
  computed: {
disabled(){
  let flag = true;
  if(this.model.hfnr){
    flag = false
  }
  return flag;
}

  },
  methods: {
    getData() {
      let params = { id: this.model.id }
      getAction('/zhshj/rclmxszx/query/list/by/id', params).then((res) => {
        if (res.success) {
          let obj = res.result[0]
          this.object = obj
        }
      })
    },
    clickSumbit() {
      
      postAction('/zhshj/rclmxszx/app-edit', this.model).then((res) => {
        if (res.success) {
         this.$toast('提交成功')
         this.$router.go(-1)
        }
      })
    },

  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  box-sizing: border-box;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // flex-wrap: wrap;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;
  margin: 20px 0;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
.imgList {
  border-top: 1px solid #dedede;
  margin: 0 12px;

  .pre-item-image {
    width: 80px;
    height: 80px;
  }
}

.audio-list {
  border-top: 1px solid #dedede;
  margin: 0 12px;
}

.time {
  color: #999999;
  font-size: 13px;
  padding: 12px;
}
.title {
  width: 100%;
  line-height: 38px;
}

.video-p {
  border-top: 1px solid #dedede;
  margin: 0 12px;
}

.video-class {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
